module.exports = __webpack_public_path__ + "img/cursoeduca.37dd11d9.png";